import { render, staticRenderFns } from "./RatingList.vue?vue&type=template&id=b7694cce&scoped=true"
import script from "./RatingList.vue?vue&type=script&lang=js"
export * from "./RatingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7694cce",
  null
  
)

export default component.exports